module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/personalization-ad0219ba552486344d164d40d5540853.svg";